import React, { useState } from "react";
import Header from "./component/Header";
import MainPanel from "./component/MainPanel";

function App() {

    const [active, setActive] = useState("home");

    const toggleActive=(selected)=>{
        setActive(selected);
        document.getElementById("mainpanel").scrollTo(0,0);
    }

    return (
        <div className="row m-0 p-0">
            <div className="col-2 m-0 p-0 side-panel">
                <Header active={active} setActive={toggleActive}/>
            </div>
            <div className="col-10 main-panel" id="mainpanel">
                <MainPanel active={active} setActive={toggleActive}/>
            </div>

        </div>
    );
}

export default App;
